"use client";

import React from "react";
import VenueMap from "./VenueMap";
import { VenueWithLocations } from "@punchup/venues";

interface VenueMapCardProps {
  venue: VenueWithLocations;
  border?: boolean; // if true, wraps the component in a rounded border (default: true)
  title?: React.ReactNode; // an optional title to display above the map
}

const VenueMapCard: React.FC<VenueMapCardProps> = ({
  venue,
  border = true,
  title,
}) => {
  return (
    <div
      className={`flex flex-col w-full bg-white ${
        border ? "rounded-xl border border-text-secondary" : ""
      }`}
    >
      {title && (
        <div className="px-5 md:px-6 pt-4 md:pt-6">
          <h2 className="text-xl mb-2 text-primary-blue font-bold">Location</h2>
        </div>
      )}
      <div
        className={`flex-1 ${title ? "px-5 md:px-6 pb-4 md:pb-6" : "p-4 md:p-6"}`}
      >
        <VenueMap venue={venue} />
      </div>
    </div>
  );
};

export default VenueMapCard;
